<script lang="ts" setup>
import type { DatePickerDate } from 'v-calendar/dist/types/src/use/datePicker.js';

import DatePickerWrapper from './DatePickerWrapper.vue';

const props = defineProps<{
  modelValue: DatePickerDate;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  masks?: Record<string, any>;
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', value: DatePickerDate): void;
}>();

const onUpdateModelValue = (value: DatePickerDate): void => {
  emits('update:modelValue', value);
};
</script>

<template>
  <UPopover
    :popper="{ placement: 'bottom-start' }"
    :ui="{ base: 'overflow-visible', background: 'bg-card' }"
  >
    <slot />

    <template #panel="{ close }">
      <DatePickerWrapper
        :model-value="props.modelValue"
        v-bind="{ ...$attrs }"
        :masks="{ weekdays: 'WWW', ...props.masks }"
        @close="close"
        @update:model-value="onUpdateModelValue"
      />
    </template>
  </UPopover>
</template>
